// src/components/common/LoadMoreButton.jsx
import React from 'react'
import Button from './Button.jsx'

export default function LoadMoreButton({ 
  hasMore, 
  loading, 
  onLoadMore, 
  className = "" 
}) {
  if (!hasMore) return null

  return (
    <div className={`text-center mt-8 ${className}`}>
      <Button
        variant="outline"
        loading={loading}
        onClick={onLoadMore}
      >
        {loading ? 'Loading...' : 'Load More'}
      </Button>
    </div>
  )
}